import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { H3 } from '../../typography/Heading';
import { P3 } from '../../typography/Paragraph';
type StepCardProps = {
  number?: number;
  title: string;
  illustration: React.ReactNode;
  content: string;
  illustrationSize?: string;
};
export function StepCard(t0) {
  const $ = _c(16);
  const {
    number,
    title,
    illustration,
    content,
    illustrationSize: t1
  } = t0;
  const illustrationSize = t1 === undefined ? "w-40 h-40" : t1;
  let t2;
  if ($[0] !== illustration || $[1] !== illustrationSize) {
    t2 = <div aria-hidden="true" className={illustrationSize}>{illustration}</div>;
    $[0] = illustration;
    $[1] = illustrationSize;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== number) {
    t3 = number !== undefined && <span aria-hidden="true" className="font-extrabold text-5xl">{number}</span>;
    $[3] = number;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== title) {
    t4 = <H3 className="font-semibold">{title}</H3>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== content) {
    t5 = <P3 className="text-balance text-center text-blue-700">{content}</P3>;
    $[7] = content;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className="flex w-full flex-1 flex-col items-center gap-2 text-center text-blue-900">{t3}{t4}{t5}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t6) {
    t7 = <li className="flex min-w-0 flex-col items-center gap-4 rounded-xl border border-borderColor bg-blue-50 p-4">{t2}{t6}</li>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}